import { useState } from 'react';
import { TextInput, PasswordInput, Button, Paper, Title, Container, Stack } from '@mantine/core';
import { useForm } from '@mantine/form';
import { notifications } from '@mantine/notifications';
import type { AxiosError } from 'axios';
import { authApi } from '../api/client';

interface LoginProps {
    onLogin: () => void;
}

export default function Login({ onLogin }: LoginProps) {
    const [loading, setLoading] = useState(false);

    const form = useForm({
        initialValues: {
            username: '',
            password: '',
        },
        validate: {
            username: (value) => (value ? null : 'Username is required'),
            password: (value) => (value ? null : 'Password is required'),
        },
    });

    const handleSubmit = async (values: { username: string; password: string }) => {
        setLoading(true);
        try {
            await authApi.login(values.username, values.password);
            notifications.show({
                title: 'Success',
                message: 'Logged in successfully',
                color: 'green',
            });
            onLogin();
        } catch (err) {
            const error = err as AxiosError<{ error: string }>;
            notifications.show({
                title: 'Error',
                message: error.response?.data?.error || 'Login failed',
                color: 'red',
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container size={420} my={40}>
            <Title ta="center" mb="xl">
                WordPress MCP Manager
            </Title>

            <Paper withBorder shadow="md" p={30} radius="md">
                <form onSubmit={form.onSubmit(handleSubmit)}>
                    <Stack>
                        <TextInput
                            label="Username"
                            placeholder="admin"
                            required
                            {...form.getInputProps('username')}
                        />

                        <PasswordInput
                            label="Password"
                            placeholder="Your password"
                            required
                            {...form.getInputProps('password')}
                        />

                        <Button type="submit" fullWidth loading={loading}>
                            Sign in
                        </Button>
                    </Stack>
                </form>
            </Paper>
        </Container>
    );
}
